import React, { useEffect, useState, useRef } from "react";
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	CardImg,
} from "reactstrap";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import {
	AvForm,
	AvField,
	AvRadioGroup,
	AvRadio,
} from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import LeadService from "services/Admin/LeadService";
import CompoundService from "services/Admin/CompoundService";
import BaseService from "services/BaseService";
import SelectOptions from "components/SelectOptions";
import { adminPrefix } from "configs/routePrefix";
import { useDispatch, useSelector } from "react-redux";
import { appendData, resetData } from "store/Mode/actions";
import "../style.scss";
import BuildingService from "services/Admin/BuildingService";
import PropertyService from "services/Admin/PropertyService";
import axios from "axios";
import CropImg from "./CropImg";

function UploadMainImageModal({
	modal,
	toggle,
	activeCanvasData,
	setActiveCanvasData,
	image,
}) {
	const [img, setImg] = useState([]);
	const [imgSrc, setImgSrc] = useState("");
	const [units, setUnits] = useState([]);
	const [percent, setPercent] = useState(0);
	const [cropModal, setCropModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const cancelTokenSource = useRef();
	const dispatch = useDispatch();
	const propertyService = new PropertyService();
	const modeData = useSelector((state) => state.Mode);

	const addImagesHandler = (e) => {
		setLoading(true);
		let files = e.target.files;
		const filesData = Object.values(files);
		const uploadedImgs = [];

		if (filesData.length) {
			// let createdFiles
			// Promise.all(
			//     filesData.map(async (file) => {
			//         let res = await new BaseService().postUpload(file, options);
			//         createdFiles = { ...res.data.data, shapes: [], fromLibrary: false };

			//     }),
			// ).then(() => {
			//     uploadedImgs.push(createdFiles)
			//     // setImg({...uploadedImgs[0] })
			//     setPercent(0)
			// })
			setImg([]);
			activeCanvasData?.shapes
				.filter((shape) => shape.highlight)
				?.map((time) => {
					new BaseService().postUpload(filesData[0], options).then((res) => {
						let createdFiles = {
							...res.data.data,
							shapes: [],
							fromLibrary: false,
						};
						uploadedImgs.push(createdFiles);
						setPercent(0);
					});
				});
			setImg(uploadedImgs);
		}
	};

	useEffect(() => {
		let filter = activeCanvasData.shapes?.filter((res) => res?.highlight);
		if (!!image?.path) {
			if (filter?.length === 1) {
				setImgSrc(image?.path);
			} else {
				setImgSrc("");
			}
		}
		setUnits(filter);
	}, [image]);

	useEffect(() => {
		return () => {
			cancelTokenSource?.current?.cancel();
		};
	}, []);

	const toggleCrop = () => setCropModal(!modal);

	const [fileName, setFileName] = useState(null);
	const [loadingCrop, setLoadingCrop] = useState(false);
	const [imageCrop, setImageCrop] = useState("");

	const onImageSelected = (e) => {
		const reader = new FileReader();
		setFileName(e.target.files[0]);
		reader.readAsDataURL(e.target.files[0]);
		reader.onload = function (e) {
			setImageCrop(reader.result);
			setCropModal(true);
		};
	};

	const uploadImage = (file) => {
		setLoadingCrop(true);

		Promise.all(units?.map((_) => new BaseService().postUpload(file))).then(
			(res) => {
				let uploadedImgs = [];
				units?.map((unit, index) => {
					if (res[index]?.status) {
						let createdFiles = {
							...unit,
							idImage: {
								...res[index].data.data,
								shapes: [],
								fromLibrary: false,
							},
						};
						uploadedImgs.push(createdFiles);
						setImgSrc(res[index].data.data?.path);
					}
				});
				setCropModal(false);
				setLoadingCrop(false);
				setPercent(0);
				setImg([...uploadedImgs]);
			}
		);
	};

	const handleValidSubmit = () => {
		if (!!img?.length) {
			let promises = img?.map((res) =>
				propertyService.changeImage({
					unit_ids: [res?.hotspot?.id],
					main_image: res?.idImage?.id,
				})
			);
			Promise.all(promises).then((res) => {
				if (res?.every((num) => num?.status === 200)) {
					setActiveCanvasData((prev) => ({
						...prev,
						shapes: prev.shapes?.map((itemData) => {
							const match = img.find((a) => a.id === itemData.id);
							if (match) {
								return {
									...itemData,
									idImage: match?.idImage,
								};
							} else {
								return itemData;
							}
						}),
					}));

					let updateData = modeData?.images?.map((imgData, ind) => {
						let match = img.find(
							(a) => a?.hotspot.id === imgData?.constrains?.id
						);
						if (activeCanvasData?.id === imgData?.id) {
							let updateShapes = imgData?.shapes?.map((imgSh) => {
								let match2 = img.find(
									(a) => a?.hotspot.id === imgSh?.hotspot?.id
								);

								if (match2) {
									return {
										...imgSh,
										idImage: match2?.idImage,
									};
								} else {
									return imgSh;
								}
							});
							return {
								...imgData,
								shapes: updateShapes,
							};
						} else if (match) {
							return {
								...imgData,
								id: match?.idImage?.id,
								path: match?.idImage?.path,
							};
						} else {
							return imgData;
						}
					});
					dispatch(appendData({ ...modeData, images: updateData }));
					toggle();
				}
			});
			return;
			propertyService.changeImage(params).then((res) => {
				if (res?.status) {
					const updatedShapes = activeCanvasData.shapes?.map(
						(itemData, itemIndex) => {
							if (itemData.highlight) {
								let imge = img[0];
								index++;
								return {
									...itemData,
									idImage: { ...imge },
								};
							} else {
								return itemData;
							}
						}
					);
					setActiveCanvasData({
						...activeCanvasData,
						shapes: [...updatedShapes],
					});
					toggle();
				}
			});
		} else {
			toast.error("Select or Upload Image");
		}
	};

	return (
		<AvForm className="form-horizontal" onValidSubmit={() => {}}>
			<Modal
				isOpen={modal}
				toggle={() => {
					if (loading) {
						cancelTokenSource.current.cancel();
					}
					toggle();
				}}
				className="scrollbar-container mt-5 internal-modal">
				<ModalHeader
					toggle={() => {
						if (loading) {
							cancelTokenSource.current.cancel();
						}
						toggle();
					}}>
					Add New Image
					<br />
				</ModalHeader>
				<ModalBody>
					<Row>
						{percent > 0 ? (
							<div className="ml-1 mr-2">
								<div className="progress mb-1 p-0 ">
									<div
										className="progress-bar progress-bar-striped"
										role="progressbar"
										style={{ width: percent + "%" }}
										aria-valuenow={`${percent}`}
										aria-valuemin="0"
										aria-valuemax="100"></div>
								</div>
							</div>
						) : (
							<div></div>
						)}
						{!!imgSrc ? (
							<Col className="parent-div">
								<CardImg
									className="position-relative"
									src={imgSrc}
									style={{
										width: "100%",
										height: "210px",
										objectFit: "cover",
										borderRadius: "10px",
									}}></CardImg>
								{/* <button
									className="position-absolute overflow-hidden text-danger fw-bold p-1 font-size-16"
									onClick={() => {
										setImgSrc([]);
									}}
									style={{
										top: "5px",
										right: "15px",
										border: "none",
										background: "white",
										borderRadius: "15px",
										height: "30px",
										width: "30px",
										paddingRight: "20px",
										paddingTop: "5px",
									}}>
									x
								</button> */}
								<button
									className="position-absolute overflow-hidden"
									style={{
										bottom: "5px",
										right: "15px",
										border: "none",
										background: "white",
										borderRadius: "19px",
										height: "38px",
										width: "38px",
										paddingRight: "20px",
										paddingTop: "5px",
									}}>
									<i className="fas fa-pen  overflow-hidden text-success p-2 "></i>
									<input
										type="file"
										name="upfile"
										accept="image/*"
										onChange={onImageSelected}
									/>
								</button>
							</Col>
						) : null}
						{!imgSrc ? (
							<Col md={12} className="parent-div my-1">
								<div className="p-2 bg-light " style={{ borderRadius: "10px" }}>
									<button
										type="button"
										className="px-4 w-100 btn-upload  font-size-16 "
										style={{
											border: "2px dashed rgb(202, 223, 247)",
											borderRadius: "10px",
											height: "150px",
											background: "#F3F3F9",
										}}>
										<div>
											<i className="fas fa-cloud-upload-alt text-success"></i>
										</div>
										<div>Click to upload or drag and drop</div>
										<p
											className="text-primary fw-bold btn-hover"
											style={{ textDecoration: "underline" }}>
											from computer
										</p>
									</button>
									<input
										type="file"
										name="upfile"
										accept="image/*"
										onChange={onImageSelected}
									/>
								</div>
							</Col>
						) : null}
						{/* {!imgSrc ? (
							<Col className="d-flex flex-wrap parent-div">
								<div
									className="mx-1 my-2 d-flex"
									style={{
										width: "80px",
										height: "70px",
										// border: img?.id === item.id ? "2px solid black" : "none",
									}}
									// onClick={() =>
									// 	setImg({ ...item, shapes: [], fromLibrary: true })
									// }
								>
									<img
										src={imgSrc}
										style={{
											width: "100%",
											height: "100%",
											objectFit: "cover",
										}}
									/>
								</div>
							</Col>
						) : null} */}
					</Row>
				</ModalBody>

				<Row className="p-0 pt-1 m-0 d-flex justify-content-between">
					<Col md={6}>
						<button
							type="button"
							onClick={toggle}
							className="btn btn-secondary w-30">
							Cancel
						</button>
					</Col>
					<Col md={6} className="d-flex justify-content-end">
						<button
							type="button"
							onClick={() => handleValidSubmit()}
							disabled={percent === 0 ? false : percent === 100 ? false : true}
							className="btn btn-success w-30">
							Submit
						</button>
					</Col>
				</Row>
			</Modal>
			{cropModal && (
				<CropImg
					modal={cropModal}
					toggle={toggleCrop}
					img={imageCrop}
					uploadImage={(file) => uploadImage(file)}
					fileName={fileName}
					loadingCrop={loadingCrop}
				/>
			)}
		</AvForm>
	);
}

export default UploadMainImageModal;
